import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Stack, Box } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import DashboardFooter from './DashboardFooter';
import HelpSystem from '../../components/help-system/HelpSystem';

import { useIsFeatureFlagEnabled } from '../../utils/FeatureFlags';
import AnnouncementBanner from '../../utils/AnnouncementBanner';

const RootStyle = styled('div')({
  display: 'flex',
  height: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(() => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%'
}));

DashboardLayout.propTypes = {
  children: PropTypes.node
};

DashboardLayout.defaultProps = {
  children: null
};
export default function DashboardLayout({ children }) {
  const [open, setOpen] = useState(false);
  const announcementOn = useIsFeatureFlagEnabled('announcement_on');

  return (
    <RootStyle>
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

      <MainStyle
        sx={{
          background: (theme) => theme.palette.background.default
        }}
      >
        {announcementOn && <AnnouncementBanner />}
        <DashboardNavbar onOpenSidebar={() => setOpen(true)} />

        <Stack sx={{ height: '100%' }} justifyContent="space-between">
          <Box sx={{ paddingBottom: '50px' }}>{children !== null ? children : <Outlet />}</Box>
          <DashboardFooter />
        </Stack>
      </MainStyle>
      <HelpSystem />
    </RootStyle>
  );
}
